import { workflowRequestDisplayStatus } from './workflowRequestListModel';
import type { ValueBadgeTone } from '../../../design-system';
import type { WorkflowRequest } from '../model';

export function workflowEffectiveDateLabel(values: Record<string, unknown>): string {
  if (values.correctionOf) return '정정할 입사일';
  if (values.transitionKind) return '전환일';
  switch (values.processType) {
    case 'LEAVE_OF_ABSENCE': return '휴직 시작일';
    case 'RETURN_FROM_LEAVE': return '복직일';
    case 'END_WORKER': return '재직 종료일';
    default: return '시행일';
  }
}

type ExecutionPresentation = { label: string; detail?: string; tone: ValueBadgeTone; afterLabel: string };
/** 결재 상태와 서버가 확인한 원장 기록을 구분합니다. 날짜만으로 반영 성공을 추정하지 않습니다. */
export function workflowExecutionPresentation(request: WorkflowRequest): ExecutionPresentation {
  const pending = { afterLabel: '요청한 값', tone: 'neutral' as const };
  if (request.status === 'CANCELLED') return { label: '취소됨 · 미반영', tone: 'neutral', afterLabel: '요청했던 값' };
  if (request.status === 'DENIED') return { label: '반려됨 · 미반영', tone: 'danger', afterLabel: '요청했던 값' };
  if (request.status === 'DRAFT') return { ...pending, label: '초안 · 미반영' };
  if (request.status === 'NEEDS_CHANGES') return { ...pending, label: '보완 대기 · 미반영', tone: 'warning' };
  if (request.status !== 'COMPLETED') return { ...pending, label: '승인 대기 · 미반영', tone: 'info' };
  const execution = request.execution;
  if (execution?.status === 'UNVERIFIED') return { label: '반영 확인 필요', detail: '결재는 완료되었지만 변경 내용의 반영을 확인하지 못했습니다.', afterLabel: '승인된 값', tone: 'warning' };
  if (execution?.status !== 'RECORDED') return { label: '승인 완료 · 반영 확인 필요', afterLabel: '승인된 값', tone: 'warning' };
  const future = workflowRequestDisplayStatus(request) === 'AWAITING_EFFECTIVE';
  return {
    label: future ? '시행 대기' : '완료',
    detail: future ? `${execution.effectiveDate!.replaceAll('-', '.')}부터 적용` : undefined,
    afterLabel: '승인된 값', tone: future ? 'info' : 'success',
  };
}
